import { ICompanyEmailSettings, IMicrosoftSettings } from "./ICompany"
import { EGender } from "./IEmployee"
import { IHolidaySettings } from "./IHolidays"
import { IPermissions, IPermissionGroup } from "./IPermissions"
import { IReference } from "./IReference"
import { ELanguage } from "./Language/languageHelper"
import { ICountriesTexts } from "./Language/languageTexts/countries"
import { IIndustriesTexts } from "./Language/languageTexts/industriesTexts"

export default interface ICompanySettingsDTO
{
    globalEmailSupport: boolean
    microsoftSettings: IMicrosoftSettings
    companyId: string
    name: string
    employees: ICompanyUser[]
    style: IStyleDTO
    OUs: IOU[]
    level: ILevel[]
    permissionGroups: IPermissionGroup[]
    defaultPermissionGroup: IReference | undefined
    allowedMailEndings: string[]
    timeSync: ETimeSyncOption
    clockodoSync: {
        email: string,
    }
    zepInstance: string
    clockodoStatis: ICompanyTimeSyncStatis
    zepStatis: ICompanyTimeSyncStatis
    calculations: ICompanyCalcualtions
    localisation: ICompanyLocalisation
    industry: keyof IIndustriesTexts
    holidaySettings: IHolidaySettings
    emailSettings: ICompanyEmailSettings
    apiKeys: ICompanyApiKey[]
    version: number;
}

export interface ICompanyApiKey
{
    id: number
    note: string
    createdAt: string
    createdBy: number
}

export enum ETimeSyncOption
{
    NONE = "none",
    CLOCKODO = "clockodo",
    ZEP = "zep",
}

export type TTimeSyncOption = ETimeSyncOption

export function isETimeSyncOption(value: string): value is ETimeSyncOption
{
    return Object.values(ETimeSyncOption).includes(value as ETimeSyncOption);
}

export enum ETimeSyncStartType
{
    /**
    MetaData + TimeEntries 2 Months - fastest
    **/
    SMALL = 'SMALL',
    /**
    MetaData + TimeEntries this year - normal speed
    **/
    NORMAL = 'NORMAL',
    /**
    MetaData + TimeEntries this year & last year - slowest
    **/
    FULL = 'FULL',
}
export enum ETimeSyncStatus
{
    IDLE = "IDLE",
    SYNCING = "SYNCING",
    SYNCED = "SYNCED",
    ERROR = "ERROR",
}
export interface ICompanyTimeSyncStatis
{
    status: ETimeSyncStatus
    lastUpdateProjects: string | null
    lastUpdateCustomer: string | null
    lastUpdateEmployeeAbsence: string | null
    lastUpdateEmployeeTimesLastYear: string | null
    lastUpdateEmployeeTimesThisYear: string | null
}
export interface ICompanyLocalisation
{
    country: keyof ICountriesTexts
    subCountry: string
    language: ELanguage
}
export interface ICompanyCalcualtions
{
    forecastMonthCount: number
    workedMonthCount: number
}
export interface IOU
{
    id: number
    parentOU?: number
    title: string
    leader: number
    employees: number[]
}
export interface ICompanyUser
{
    id: number
    // userName: string
    firstname: string
    lastname: string
    gender: EGender
    email: string
    permissions: IPermissions;
    permissionGroup: IReference;
}
export interface ISkillSmall
{
    title: string,
    id: number
}

export interface ILevel
{
    level: number,
    title: string,
    description: string,
    helperText: string,
}

export interface IStyleDTO
{
    logoId: string | null
    primary: string
    secondary: string
    onSecondary: string
    onPrimary: string
}
export enum EEmailTransferOption
{
    Exchange = "exchange",
    Global = "global",
    NoEmail = "noEmail"
}